import { authFetch } from "@/plugins/axiosConfig";

const stopStore = {
  namespaced: true,
  // 강제 매도 설정, 강제 매수 중지 state 초기값
  state: {
    GLOBAL: {
      LONG: {
        forceSell: {},
        forceStop: {},
      },
      SHORT: {
        forceSell: {},
        forceStop: {},
      },
    },
    SYMBOLS: {
      LONG: {
        forceSell: [],
        forceStop: [],
      },
      SHORT: {
        forceSell: [],
        forceStop: [],
      },
    },
  },

  getters: {
    // 강제 매도 설정, 매수중지 조회

    // 강제 매수 중지 (전역) 조회
    GET_STOP_GLOBAL_LONG: (state) => state.GLOBAL.LONG.forceStop,
    GET_STOP_GLOBAL_SHORT: (state) => state.GLOBAL.SHORT.forceStop,
    // 강제 매수 중지 심볼 별 조회
    GET_STOP_SYMBOLS_LONG: (state) => state.SYMBOLS.LONG.forceStop,
    GET_STOP_SYMBOLS_SHORT: (state) => state.SYMBOLS.SHORT.forceStop,
    // 강제 매도 (전역) 조회
    GET_SELL_GLOBAL_LONG: (state) => state.GLOBAL.LONG.forceSell,
    GET_SELL_GLOBAL_SHORT: (state) => state.GLOBAL.SHORT.forceSell,
    // 강제 매도 심볼 별 조회
    GET_SELL_SYMBOLS_LONG: (state) => state.SYMBOLS.LONG.forceSell,
    GET_SELL_SYMBOLS_SHORT: (state) => state.SYMBOLS.SHORT.forceSell,
  },
  mutations: {
    // 강제 매도 설정, 매수 중지 state 저장

    // global(전체 적용) 객체 저장
    MU_UPDATE_STOP: (state, payload) => {
      if (payload != null) {
        const { autoStopSeq, symbol, positionSide, triggerPercent } = payload;
        if (symbol === "GLOBAL") {
          state[symbol][positionSide].forceStop = {
            autoStopSeq,
            triggerPercent,
            symbol,
          };
        } else {
          if (state.SYMBOLS[positionSide].forceStop.findIndex.length > 0) {
            const symbolIndex = state.SYMBOLS[positionSide].forceStop.findIndex(
              (f) => f.symbol === symbol
            );
            if (symbolIndex >= 0) {
              state.SYMBOLS[positionSide].forceStop[symbolIndex] = {
                autoStopSeq,
                symbol,
                triggerPercent,
              };
            } else {
              state.SYMBOLS[positionSide].forceStop.push({
                autoStopSeq,
                symbol,
                triggerPercent,
              });
            }
          } else {
            state.SYMBOLS[positionSide].forceStop.push({
              autoStopSeq,
              symbol,
              triggerPercent,
            });
          }
        }
      }
    },
    // 강제 매도 단일건 저장
    MU_UPDATE_SELL: (state, payload) => {
      const { autoSellSeq, symbol, positionSide, sellPercent } = payload;
      if (symbol === "GLOBAL") {
        state[symbol][positionSide].forceSell = {
          autoSellSeq,
          sellPercent,
          symbol,
        };
      } else {
        if (state.SYMBOLS[positionSide].forceSell.findIndex.length > 0) {
          const symbolIndex = state.SYMBOLS[positionSide].forceSell.findIndex(
            (f) => f.symbol === symbol
          );
          if (symbolIndex >= 0) {
            state.SYMBOLS[positionSide].forceSell[symbolIndex] = {
              autoSellSeq,
              symbol,
              sellPercent,
            };
          } else {
            state.SYMBOLS[positionSide].forceSell.push({
              autoSellSeq,
              symbol,
              sellPercent,
            });
          }
        } else {
          state.SYMBOLS[positionSide].forceSell.push({
            autoSellSeq,
            symbol,
            sellPercent,
          });
        }
      }
    },
    // 코인별 양방향 데이터 저장
    MU_UPDATE_STOP_LIST: (state, payload) => {
      for (var i = 0; i < payload.length; i++) {
        const { autoStopSeq, symbol, positionSide, triggerPercent } =
          payload[i];
        if (symbol === "GLOBAL") {
          state[symbol][positionSide].forceStop = {
            autoStopSeq,
            triggerPercent,
          };
        } else {
          // TODO : 데이터 추가 및 수정
          if (state.SYMBOLS[positionSide].forceStop.findIndex.length > 0) {
            const symbolIndex = state.SYMBOLS[positionSide].forceStop.findIndex(
              (f) => f.symbol === symbol
            );
            if (symbolIndex >= 0) {
              state.SYMBOLS[positionSide].forceStop[symbolIndex] = {
                autoStopSeq,
                symbol,
                triggerPercent,
              };
            } else {
              state.SYMBOLS[positionSide].forceStop.push({
                autoStopSeq,
                symbol,
                triggerPercent,
              });
            }
          } else {
            state.SYMBOLS[positionSide].forceStop.push({
              autoStopSeq,
              symbol,
              triggerPercent,
            });
          }
        }
      }
    },
    MU_UPDATE_SELL_LIST: (state, payload) => {
      for (var i = 0; i < payload.length; i++) {
        const { autoSellSeq, symbol, positionSide, sellPercent } = payload[i];
        if (symbol === "GLOBAL") {
          state[symbol][positionSide].forceSell = {
            autoSellSeq,
            sellPercent,
          };
        } else {
          // TODO : 데이터 추가 및 수정
          if (state.SYMBOLS[positionSide].forceSell.findIndex.length > 0) {
            const symbolIndex = state.SYMBOLS[positionSide].forceSell.findIndex(
              (f) => f.symbol === symbol
            );
            if (symbolIndex >= 0) {
              state.SYMBOLS[positionSide].forceSell[symbolIndex] = {
                autoSellSeq,
                symbol,
                sellPercent,
              };
            } else {
              state.SYMBOLS[positionSide].forceSell.push({
                autoSellSeq,
                symbol,
                sellPercent,
              });
            }
          } else {
            state.SYMBOLS[positionSide].forceSell.push({
              autoSellSeq,
              symbol,
              sellPercent,
            });
          }
        }
      }
    },

    MU_TEMP: () => {},
  },
  actions: {
    // 강제 매수 중지 저장.
    AT_SAVE_STOP: async ({ commit }, payload) => {
      const response = await authFetch.post(`/api/order/autostop`, payload);
      if (response.status === 200 || response.status === 201) {
        alert("성공적으로 저장되었습니다.");
        commit("MU_UPDATE_STOP", response.data);
      } else {
        alert("저장에 실패했습니다 잠시 후 이용해주시기 바랍니다.");
      }
    },
    // 강제 매도 설정 저장.
    AT_SAVE_SELL: async ({ commit }, payload) => {
      const response = await authFetch.post(`/api/order/autosell`, payload);
      if (response.status === 200 || response.status === 201) {
        alert("성공적으로 저장되었습니다.");
        commit("MU_UPDATE_SELL", response.data);
      } else {
        alert("저장에 실패했습니다. 잠시 후 다시 이용해주시기 바랍니다.");
      }
    },

    // 강제 매수 중지 전체 조회
    AT_LOAD_STOP_ALL: async ({ commit }) => {
      const response = await authFetch.get(`/api/order/autostop`);

      const resultList = response.data;
      commit("MU_UPDATE_STOP_LIST", resultList);
    },
    AT_LOAD_SELL_ALL: async ({ commit }) => {
      const response = await authFetch.get(`/api/order/autosell`);
      const resultList = response.data;
      commit("MU_UPDATE_SELL_LIST", resultList);
    },

    // 강제 매수 중지 설정 (전역) 데이터 조회
    AT_LOAD_STOP: async ({ commit }, payload) => {
      const response = await authFetch.get(
        `/api/order/autostop/unit/${payload.positionSide}?symbol=${payload.symbol}`
      );

      const resultMap = response.data;

      commit("MU_UPDATE_STOP_GLOBAL", resultMap);
    },
    AT_LOAD_STOP_BOTH: async ({ commit }, payload) => {
      const response = await authFetch.get(
        `/api/order/autostop/both/${payload.symbol}`
      );
      commit("MU_UPDATE_STOP_LIST", response.data);
    },
  },
};

export default stopStore;
